<template>
    <div>
        <h4 class="text-center thank-you-heading">
            {{ heading }}
        </h4>
        <p
            class="text-center paragraph"
            style="padding: 0px icon-customer-profil30px"
        >
            Almost done! Please enter the 6 digit password that has been sent to
            your email
        </p>
        <b-form-group id="input-group-1" label="otp-code" label-for="otpcode">
            <b-form-input
                id="otpcode"
                v-model="otpCode"
                v-validate="{ required: true, min:6 ,max: 6, regex: /^([0-9]*)$/ }"
                type="text"
                required
                name="OTP code"
                autocomplete="no"
                placeholder="Enter OTP code"
            ></b-form-input>
            <span v-if="isError" class="text-center color-red">{{
                isError
            }}</span>
        </b-form-group>
        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
                    <!-- <b-button
              type="button"
              variant="primary"
              class="primary-add-btn"
              @click="initRecaptcha"
          >
              <span class="btn-text"
                  ><span v-if="countDown > 0">Submit</span
                  ><span v-else>Resend Code</span></span
              >
          </b-button> -->
                    <popup-button
                        btn-type="button"
                        btn-variant="primary"
                        :btn-label="
                            countDown > 0 ? 'Submit OTP' : 'Resend Code'
                        "
                        :class="loading || isSubmitting ? 'disabled' : ''"
                        :disabled="loading || isSubmitting"
                        @onClickButton="initRecaptcha"
                    >
                        <!-- <span class="btn-text"
                ><span v-if="countDown > 0">Submit</span
                ><span v-else>Resend Code</span></span
            > -->
                    </popup-button>
                </div>
            </div>
        </div>
        <p
            v-if="countDown > 0"
            class="text-center paragraph fs-13 my-3"
            style="padding: 0px icon-customer-profil30px"
        >
            Resend Code in {{ countDown }} seconds
        </p>
        <!-- <p
        class="text-center paragraph fs-13 my-3"
        style="padding: 0px icon-customer-profil30px"
    >
        I agree to <a href="www.google.com">Terms and Policies</a>
    </p> -->
        <b-modal
            ref="modalRecaptcha"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
        >
            <div class="col-sm-10">
                <recaptcha @onVerify="onVerify"> </recaptcha>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Recaptcha from '@/components/registration/Recaptcha.vue'
import request from '@/utils/request'
import PopupButton from '@/components/registration/PopupButton.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        Recaptcha,
        PopupButton,
    },

    props: {
        data: { type: Object },
        heading:{type:String}
    },
    data() {
        return {
            otpCode: '',
            resendDisable: true,
            countDown: 120,
            responseData: '',
            isError: '',
            recaptchaResponse: '',
            isSubmitting: false,
        }
    },

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */

    mounted() {
        this.countDownTimer()
        // console.log('PropsData: ' + JSON.stringify(this.data))
    },
    methods: {
        async onVerify(response) {
            if (response) {
                this.recaptchaResponse = response
                this.$refs.modalRecaptcha.hide()
                this.submitOTP()
            }
        },

        async initRecaptcha() {
            if (this.countDown > 0) {
                this.isSubmitting = true
                const result = await this.$validator.validateAll()

                if (result) {
                    // this.$refs.modalRecaptcha.show()
                    this.submitOTP()
                }
                const digits=this.otpCode.length
                 if(digits>6){
                    this.isError="OTP should not be greater than 6 digits"
                    this.$store.commit('setError', this.isError)
                    this.isSubmitting = false
                }
                if(digits<6)
                { this.isError="OTP should not be less than 6 digits"
                    this.$store.commit('setError', this.isError)
                    this.isSubmitting = false
                }
            } else {
                this.submitResend()
            }
        },

        async submitOTP()
        {
            const result = await this.$validator.validateAll()

            if (result) {
                let tempData = {
                    otp: this.otpCode,
                    token: this.data.data.token,
                }
                this.$emit('verificationStatus',tempData )
            }
        },
        async submitOTPOld() {
            this.$store.commit('setLoading', true)

            const result = await this.$validator.validateAll()

            if (result) {
                const formData = {
                    otpCode: this.otpCode,
                    token: this.data.data.token,
                    mobileNo: this.data.data.phoneNumber,
                    cToken: this.recaptchaResponse,
                }

                let { data } = await request({
                    url: `/configurations/verify-otp`,
                    method: 'post',
                    data: formData,
                })
                    data.data=this.$decrypt(data.data)
                if (data) {
                    this.$emit('verificationStatus', data.data)

                    if (data.data.verificationStatus == false) {
                        this.isError = data.data.message
                    }
                    //  else {

                    //     // this.$emit('verificationStatus', data.data)
                    // }
                } else {
                }
            } else {
                // this.$store.commit('setError', this.errors.all()[0])
             
                
            }

            this.$store.commit('setLoading', false)
        },

        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                this.isError =
                    'Your OTP code is expired, please click resend OTP'
                this.resendDisable = false
            }
        },
        submitResend() {
            this.$emit('reSendOTP', '')
            this.initCountDown()
        },
        initCountDown() {
            this.countDown = 120
            this.countDownTimer()
            this.isError = null
        },
    },
}
</script>
<style scoped>
p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
}
.icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
}
</style>
